import React, {useState} from 'react';
import {BuscadorContactos} from './BuscadorContactos';
import {listaContactos} from './listaContactos';
import {ContactoMen} from './ContactoMen';

/* Exporting the following: */
export const ContactosMensajes = () => {
	/* Creating a state variable called FiltroMessage and a function called setFiltroMessage. */
	const [FiltroMessage, setFiltroMessage] = useState('');

	const lista = listaContactos();

	/* Returning the following: */
	return (
		<div className='contactosMensajes'>
			<BuscadorContactos
				FiltroMessage={FiltroMessage}
				setFiltroMessage={setFiltroMessage}
			/>
			{lista.map((element, key) =>
				element.nombreContacto.toLowerCase().includes(FiltroMessage.toLowerCase()) ? (
					<ContactoMen
						nombreContacto={element.nombreContacto}
						imagenContacto={element.imagenContacto}
						horaUltimoMensaje={element.horaUltimoMensaje}
						key={key}
					/>
				) : null
			)}
		</div>
	);
};
